<script>
    import R, {LOADER} from "../lib/js/requests";
    import {router} from '../lib/Router/Router.svelte';
    import department$ from "../lib/stores/department$.js";
    import {RESERVATION_STATUS} from "../lib/js/constants.js";

    export let hash;

    let reservation = null;

    const load = () => {
        const onSuccess = result => {
            reservation = result;
        }

        const onFailure = err => {
            router.go("/not-found")();
        };

        R.handle(R.reservation.details, hash, onSuccess, onFailure, LOADER.POPUP);
    }

    load();
</script>

<section class="py-5">
    <div class="container">
        {#if reservation}

            {#if reservation.status == RESERVATION_STATUS.CANCELED}
                <h1 class="mb-3">Payment canceled</h1>
                <p class="mb-5">
                    The payment for your booking has been cancelled.
                </p>
            {/if}
            {#if reservation.status == RESERVATION_STATUS.FAILED}
                <h1 class="mb-3">The payment failed</h1>
                <p class="mb-5">
                    Your booking payment could not be completed.
                </p>
            {/if}

            <p>
                Please click the link below to try again.
            </p>
            <a href="/{$department$.link_code}/checkout/{reservation.hash}" class="btn btn-primary fw-semibold px-3 py-3">Retry Payment</a>
        {/if}
    </div>
</section>